module.exports = __webpack_public_path__ + "img/yz2.c4637f84.png";